<template>
  <div>
    <div class="m-0 pt-1 mx-auto">
      <div :class="tamanioTitulo + claseTituo">{{ titulo }}</div>
    </div>
    <b-col
      cols="12"
      lg="10"
      class="text-azul text-center text-lg-center px-4 border-bottom pb-2 border-azul-claro2 border-2 gilmer mx-auto"
    >
      <!-- Usamos v-html para permitir contenido HTML en subtitulo -->
      <span class="subtitulo-cursiva" v-html="subtitulo"></span>
    </b-col>
  </div>
</template>

<script>
export default {
  props: ["titulo", "subtitulo", "tamanioTitulo"],
  data() {
    return {
      claseTituo:
        " gilmer text-azul mt-2 px-3 px-lg- font-weight-bold text-center"
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generales/TituloRegistro.vue